/**
 * 带 Token 的 fetch（与 web 项目一致）
 */
import { getToken } from './auth.js';

export function fetchWithAuth(url, options = {}) {
  const token = getToken();
  const headers = new Headers(options.headers || {});
  if (token) {
    headers.set('Authorization', `Bearer ${token}`);
  }
  return fetch(url, { ...options, headers });
}
